import { MotiveDataProps } from './props';
import { useMotiveData } from './hook';
import Loading from '../../../../../components/general/loadings/loading';
import { Grid } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { Checkbox } from '../../../../../components/general/fields/checkbox';

export const MotiveData = ({ motive, loading }: MotiveDataProps) => {
    const { formik } = useMotiveData(motive);
    const types = (motive?.parent as string[])
        ?.map((option: any) => option?.name)
        .join(', ');

    return loading ? (
        <Loading />
    ) : (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
        >
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Nombre"
                    name="name"
                    size="small"
                    value={formik.values.name}
                    onChange={undefined}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Tipo PQR"
                    name="parent"
                    size="small"
                    value={types}
                    onChange={undefined}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Descripción"
                    name="extra"
                    size="small"
                    value={formik.values.extra}
                    onChange={undefined}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <Checkbox
                    label="Activo"
                    checked={Boolean(formik.values.active)}
                    onChange={() => {
                        formik.setFieldValue('active', !formik.values.active);
                    }}
                />
            </Grid>
        </Grid>
    );
};
